var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 50 65",
    width: "50pt",
    height: "65pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_N8WAuyb9wx2POirlpRnhgzV1YkwBaotO"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_N8WAuyb9wx2POirlpRnhgzV1YkwBaotO)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 35.909 2.5 L 14.091 2.5 C 10.327 2.5 7.273 5.555 7.273 9.318 L 7.273 55.682 C 7.273 59.445 10.327 62.5 14.091 62.5 L 35.909 62.5 C 39.673 62.5 42.727 59.445 42.727 55.682 L 42.727 9.318 C 42.727 5.555 39.673 2.5 35.909 2.5 Z  M 25 59.773 C 22.736 59.773 20.909 57.945 20.909 55.682 C 20.909 53.418 22.736 51.591 25 51.591 C 27.264 51.591 29.091 53.418 29.091 55.682 C 29.091 57.945 27.264 59.773 25 59.773 Z  M 37.273 48.864 L 12.727 48.864 L 12.727 10.682 L 37.273 10.682 L 37.273 48.864 Z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/IconPhone.e3c5a0a3c7ed90b68ff6062bb853f824.svg";
export { ForwardRef as ReactComponent };